import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

export default {

    async pegaSubitem(subItemID = {}){

        let subItem;

        try{

            //==================================================================//
            //=========================== Pega Subitem =========================//
            //==================================================================//

            subItem = await ERP.getOneById(Schema.JOB_SUBITEMS, subItemID);
            if(subItem.status != 200){
                throw subItem;
            }

            console.log(subItem);


        }catch(e){

            console.log(e);
            return subItem;

        }

        return subItem;

    },

    async pegaSubitens(subItensIDs = []){

        let subItens;

        try{

            //==================================================================//
            //========================= Pega Subitens ==========================//
            //==================================================================//

            subItens = await ERP.getManyById(Schema.JOB_SUBITEMS, subItensIDs);
            if(subItens.status != 200){
                throw subItens;
            }

            console.log(subItens);


        }catch(e){

            console.log(e);
            return subItens;

        }

        return subItens;

    },

    async criaSubitem(subItemValores = {}){

        let subItem;

        try{

            //==================================================================//
            //=========================== Cria Subitem =========================//
            //==================================================================//

            subItemValores = {
                status: "Em Desenvolvimento",
                ...subItemValores,
            }

            subItem = await ERP.postOne(Schema.JOB_SUBITEMS, subItemValores);
            if(subItem.status != 200){
                throw subItem;
            }

            console.log(subItem);


        }catch(e){

            console.log(e);
            return subItem;

        }

        return subItem;

    },

    async alteraSubitem(subItemValores = {}){

        let subItem;

        try{

            //==================================================================//
            //========================== Altera Subitem ========================//
            //==================================================================//

            subItem = await ERP.patchOne(Schema.JOB_SUBITEMS, subItemValores);
            if(subItem.status != 200){
                throw subItem;
            }

            console.log(subItem);


        }catch(e){

            console.log(e);
            return subItem;

        }

        return subItem;

    },

    async alterarSubitens(subItensValores = []){

        let subItens;

        try{

            //==================================================================//
            //======================== Altera Subitens =========================//
            //==================================================================//

            subItens = await ERP.patchMany(Schema.JOB_SUBITEMS, subItensValores);
            if(subItens.status != 200){
                throw subItens;
            }

            console.log(subItens);

        }catch(e){

            console.log(e);
            return subItens;

        }

        return subItens;

    },

    async removeSubItem(subItemValores = {}){

        let subItem;

        try{

            //==================================================================//
            //========================== Remove Subitem ========================//
            //==================================================================//

            subItemValores = {
                ...subItemValores,
                status: "Cancelado",
            }

            subItem = await this.alteraSubitem(subItemValores)
            if(subItem.status != 200){
                throw subItem;
            }

        }catch(e){

            console.log(e);
            return subItem;

        }

        return subItem;

    },

}